const SetWrapperMinHeight = {
  minHeight: "200px",
};

export default {
  SetWrapperMinHeight,
};
